import { connect } from 'react-redux'
import { getJiaBanYC,getJiaBanYCChecklist,deleteJiaBanYC} from './actions'
import Setting from './main'


const mapDispatchToProps = {
    getJiaBanYC,
    getJiaBanYCChecklist,
    deleteJiaBanYC
}
const mapStateToProps = (state) => {
  return {
    ...state.JiaBanYCList
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
